export const SET_ACTIVE_CUSTOMER = 'customerReducer/SET_ACTIVE_CUSTOMER'

export const onActiveCustomerChange = (val) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_CUSTOMER,
    payload: val
  })
}
